import { render } from "./RippleButton.vue?vue&type=template&id=5ce209b8&scoped=true"
import script from "./RippleButton.vue?vue&type=script&lang=js"
export * from "./RippleButton.vue?vue&type=script&lang=js"

import "./RippleButton.vue?vue&type=style&index=0&id=5ce209b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce209b8"]])

export default __exports__